module.exports = __webpack_public_path__ + "img/fopeaVacaMuerta5.df333de6.jpg";